import { useStore } from '../lib/store.ts'
import { Prose, Speak, TopBar } from '../components/ui.tsx'

export function InsightView({ moduleId, id }: { moduleId: string; id: string }) {
  const { idx } = useStore()
  const m = idx.moduleById.get(moduleId)
  const insight = m?.insights.find((i) => i.id === id)
  if (!m || !insight) return <div className="screen">Пояснення не знайдено</div>

  return (
    <>
      <TopBar title={m.title} />
      <div className="screen stack">
        <h1>{insight.title}</h1>
        <div className="card"><Prose text={insight.body} /></div>

        {insight.examples && insight.examples.length > 0 && (
          <section className="stack--tight stack">
            <h3>Приклади</h3>
            {insight.examples.map((ex, i) => (
              <div className="example" key={i}>
                <div className="row row--between">
                  <span className="example__pl">{ex.pl}</span>
                  <Speak text={ex.pl} small />
                </div>
                <span className="example__uk">{ex.uk}</span>
                {ex.note && <span className="example__note">{ex.note}</span>}
              </div>
            ))}
          </section>
        )}

        <a className="btn btn--wide" href={`#/module/${m.id}`}>Назад до модуля</a>
      </div>
    </>
  )
}
